import React, { Component } from 'react';
import {
    withRouter
} from 'react-router-dom';

import {
    Layout,
    Page,
    Card,
    Text,
    Badge,
} from '@shopify/polaris';
import SkeltonLoading from "../../../components/SkeltonLoading";
import {
    reqGetInstantPageSwitch,
    reqSetInstantPageSwitch
} from '../../../api';

import Switch from "react-switch";
import './index.css';

import { connect } from 'react-redux'
import { setStorePageStatus } from '../../../redux/actions/getAppPublicData';
import Language from '../../../i18n/Language';
import utils from '../../../utils/utils';
import FaqCardBox from '../../../components/FaqCardBox';
import { store } from '../../../redux/store';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
const t = Language;

class indexClass extends Component {
    state = {
        loadingPage: true,
        isOpenState: false,

        logoList: [
            'adidas',
            'shopify',
            'rakuten',
            'interflora',
            'pepsico',
            'islam',
            'lifehack',
        ], // logo列表

        showToastText: '',
        showToast: false,
        showToastIserror: false,
        durationTime: 5000,

        loadingSwitch: true, // 开关loading

        questionList: {
            speed: {
                title: "Why the Speed Score Didn't Changed?", 
                tag: [
                    "Why there's a decrease on my page speed scores when testing in GTmetrix or Google PageSpeed Insights? And why?",
                    "Page Speed Boost uses the cheating latency which helps you preloading a page right before a user clicks on it. The app does not actually change the page load speed of your website, it preloads links on your website for your visitors.",
                    "So if you test your website speed on GTmetrix or Google PageSpeed Insights, there won't be any changes on your page speed scores. If you encountered any difference at scores, it's not done by our app.",
                ]
            },
            feature: {
                title: "How does this feature help my store?", 
                tag: ["Amazon and others found that", "cutting 100 milliseconds of latency improve sales by 1%.", "This app will help improve your conversions."]
            },
            work: {
                title: "How does this feature work?", 
                tag: ["When your customers hover a link for more than 65 ms, this app will automatically request the link's destination. This typically results in an", "average perceived reduction of latency of 200-300 ms."]
            },
        }, // 问题列表
        themeAppExtensionUrl: '',
    };

    UNSAFE_componentWillMount() {
        if (this.props.public.InstantPageSwitch !== -1) {
            this.setState({
                isOpenState: Boolean(this.props.public.InstantPageSwitch),
                loadingPage: false,
                loadingSwitch: true,
            })
        }
        this.getInstantPageData();
    }

    componentDidMount() {
        // 判断是否已经缓存到redux中 如果缓存了则使用缓存的值
        let _store = store.getState().public;
        this.setState({
            themeAppExtensionUrl: _store.publicInit?.other_options.seoant_core_url || '',
        })
    }

    // 获取state
    getInstantPageData = async () => {
        const res = await reqGetInstantPageSwitch();
        if (res.ack === 1) {
            this.setState({
                isOpenState: Boolean(res.data.status),
            }, () => {
                this.props.changeStorePageStatus(Number(Boolean(res.data.status)));
            })
        } else {
            this.props.toggleToast(res.msg, true);
        }

        if (res) {
            this.setState({
                loadingPage: false,
                loadingSwitch: false,
            })
        }
    }

    // 开关操作 
    handleCheckChange = (state = 0) => {
        if(state === 1) {
            if(!this.state.isOpenState) {
                this.setState({
                    isOpenState: true,
                    loadingSwitch: true,
                }, () => {
                    let state = Number(Boolean(this.state.isOpenState));
                    this.setPageStatus(state);
                })
            }
        } else {
            this.setState({
                isOpenState: !this.state.isOpenState,
                loadingSwitch: true,
            }, () => {
                let state = Number(Boolean(this.state.isOpenState));
                this.setPageStatus(state);
            })
        }
    }

    // 保存状态
    setPageStatus = async (val) => {
        const res = await reqSetInstantPageSwitch({ status: val });
        if (res.ack === 1) {
            this.props.toggleToast(t("Success"), false);
            this.props.changeStorePageStatus(Number(Boolean(val)));
            this.setState({
                loadingSwitch: false,
            })
        } else {
            this.setState({
                isOpenState: !Boolean(val),
                loadingSwitch: false,
            })
            this.props.toggleToast(res.msg, true);
        }
    }

    // 跳转外部链接
    jumpOutUrl = () => {
        window.open('https://instant.page/');
    }

    // 返回
    goBack = () => {
        utils.routeJump(this, '/speedOpt')
    }

    render() {
        const {
            state: {
                loadingPage,
                isOpenState,
                logoList,
                loadingSwitch,
                questionList,
                themeAppExtensionUrl,

            },

        } = this;

        // 顶部开关
        const TopSwitchBlock = <Card>
            <div className='flex_layout instant_page_top'>
                <div className='instant_img'>
                    <img src='/indoorImg/InstantPage.png' alt='Instant-Page' />
                </div>
                <div>
                    <div className='boost_web'>
                        <Text variant="headingMd" as="h2">{t("Boost Your Website Speed By")}&nbsp;<span className='from_page' onClick={this.jumpOutUrl}>{t("instant page")}.</span></Text>
                        {
                            isOpenState ? <Badge tone='success'>{t("On")}</Badge> :
                                <Badge>{t("Off")}</Badge>
                        }
                        <div>
                            {loadingSwitch && <img className="Loading" src="/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
                            <Switch disabled={loadingSwitch} onChange={this.handleCheckChange} checked={isOpenState} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
                        </div>
                    </div>
                    <p className='boost_tip'>
                        {/* {t("Before using this function, please enable the APP embed block.")} */}
                        {t("Before using this function, please enable the")}&nbsp;<span className='open_instant' onClick={() => {
                            window.open(themeAppExtensionUrl)
                        }}>{t("APP embed block")}</span>.
                    </p>
                </div>
            </div>
        </Card>

        // 信任logo
        const TrustLogo = <div className='trust_box'>
            <Text variant="headingMd" as="h2">{t("Trusted By")}:</Text>
            <div className='trust_logo_list'>
                {
                    logoList.map(img => {
                        return <div key={img}>
                            <img src={`/trust_logo/${img}.png`} alt={img} />
                        </div>
                    })
                }
            </div>
        </div>

        // 常见问题
        const FrequentAsk = <FaqCardBox FaqList={questionList} />

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 最终页面
        const pageContent = !loadingPage ? <Page 
            title={
                <div style={{ display: "flex", alignItems: "center" }}>
                    {t("Instant Page")}
                </div>
            }
            backAction={{
                content: t("Instant Page"), 
                onAction: this.goBack,
            }}
        >
            <div className='instant_page'>
                <title>SEOAnt - Instant Page</title>
                <Layout>
                    <Layout.Section>
                        {TopSwitchBlock}
                        {TrustLogo}
                        {FrequentAsk}
                    </Layout.Section>
                </Layout>

                {/* 底部 */}
                {FooterHelpBox}
            </div>
        </Page> : <SkeltonLoading />;


        return pageContent;
    }

}

const mapStateToProps = state => {
    return state
}
const mapDispatchToProps = dispatch => ({
    // 缓存
    changeStorePageStatus(val) {
        dispatch(setStorePageStatus(val));
    },
})

indexClass = connect(
    mapStateToProps,
    mapDispatchToProps
)(indexClass);

export default withRouter(indexClass);
